import HMCore, { setImgixConfig, setSeoConfig } from '@hatfieldmedia/hmcore'
import '@hatfieldmedia/hmcore/style.css'
import { createPinia } from 'pinia'
import 'virtual:image-meta' // Initialize image metadata from images.meta.json
import 'virtual:org-schema' // Initialize organization schema.org data from org.schema.json
import 'virtual:video-meta' // Initialize video metadata from videos.meta.json
import { ViteSSG } from 'vite-ssg'
import App from './App.vue'
import { routes } from './router/routes'

// Configure SEO defaults
// __SITE_BASE_URL__ is injected at build time by hmcore-deploy
declare const __SITE_BASE_URL__: string
const siteBaseUrl =
  typeof __SITE_BASE_URL__ !== 'undefined' ? __SITE_BASE_URL__ : 'https://your-domain.com'

setSeoConfig({
  baseUrl: siteBaseUrl,
  titleSuffix: ' | M6 Elite Combine',
  defaultImage: '/media/images/mpower6-elite-banner-image-cropped.jpg',
  twitterCard: 'summary_large_image',
})

// Configure imgix for image optimization
// __IMGIX_DOMAIN__ is injected at build time by hmcore-deploy from shared.tfvars
declare const __IMGIX_DOMAIN__: string
const imgixDomain = typeof __IMGIX_DOMAIN__ !== 'undefined' ? __IMGIX_DOMAIN__ : ''
if (imgixDomain) {
  setImgixConfig({ domain: imgixDomain })
}

// oxlint-disable-next-line no-unused-vars  - not using router and initialState in this callback, but keeping to show they can be used
export const createApp = ViteSSG(App, { routes }, ({ app, router, initialState }) => {
  const pinia = createPinia()
  app.use(HMCore)
  app.use(pinia)
})
